var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPharmacylock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2562_2369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1526 24.6618H14.6834C14.1074 24.6618 13.6377 24.1843 13.6377 23.5988V15.9546C13.6377 15.3285 14.3998 14.7429 14.6701 14.1753C15.0555 13.378 14.9935 12.6934 14.9935 12.6934",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1523 24.6618H21.6216C22.1976 24.6618 22.6673 24.1843 22.6673 23.5988V15.9546C22.6673 15.3285 21.9096 14.7429 21.6349 14.1753C21.2494 13.378 21.3115 12.6934 21.3115 12.6934",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.668 17.2891H17.1738V21.9873H22.4996",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2465 10.373H21.0552C21.4451 10.373 21.7641 10.6974 21.7641 11.0938V11.9721C21.7641 12.3685 21.4495 12.6884 21.0596 12.6884H15.2509C14.861 12.6884 14.542 12.364 14.542 11.9676V11.0893C14.542 10.6929 14.8566 10.373 15.2465 10.373Z",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.332031 10.8828V22.2477C0.332031 23.581 1.39541 24.6621 2.70691 24.6621H11.245",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.332031 10.8829C0.332031 8.87843 1.93153 7.25231 3.90321 7.25231M3.90321 7.25231H6.10529M3.90321 7.25231H7.13323V3.96852C7.13323 1.96402 8.73272 0.337891 10.7044 0.337891",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.332031 10.8829C0.332031 5.05861 4.97545 0.337891 10.7044 0.337891H16.3093C17.51 0.337891 18.4848 1.32888 18.4848 2.5496V7.92798",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07764 10.5898H3.22559V15.4862",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02402 10.5898C5.71964 10.5898 6.28235 11.1619 6.28235 11.8691C6.28235 12.5763 5.71964 13.1529 5.02402 13.1529H3.2207",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75391 13.1523L6.16288 15.4857",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51172 11.9141L11.4493 15.4861",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4493 11.9141L8.51172 15.4861",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16309 18.9453H11.2141",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.22559 21.6074H11.2142",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2562_2369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacylock);
export default __webpack_public_path__ + "static/media/pharmacylock.2af8cc0db5f160b53702e8f55a06038d.svg";
export { ForwardRef as ReactComponent };